import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import MapPage from "./pages/MapPage";
import { BlogList, BlogDetail } from "./pages/Blog";
import Contact from "./pages/Contact";
import Subscription from "./pages/Subscription";
import { Login, Register } from "./pages/Auth";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors/>
          <Header/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/carte" element={<MapPage/>}/>
            <Route path="/blog" element={<BlogList/>}/>
            <Route path="/blog/:slug" element={<BlogDetail/>}/>
            <Route path="/abonnement" element={<Subscription/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/connexion" element={<Login/>}/>
            <Route path="/inscription" element={<Register/>}/>
            <Route path="/paiement/succes" element={<PaymentSuccess/>}/>
            <Route path="/paiement/annule" element={<PaymentCancel/>}/>
            <Route path="/admin" element={<Admin/>}/>
          </Routes>
          <Footer/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
